import Home from "./views/Home.vue";
import NotImplemented from "./components/NotImplemented.vue";
import type { RouterOptions } from "vue-router";
import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import distributorRoutes, { distributorRouteNames } from "./views/distributor/distributorRoutes";
import distributorReportRoutes, {
  distributorReportRouteNames,
} from "./views/distributorReport/distributorReportRoutes";

import accessRequestRoutes, { accessRequestRouteNames } from "./views/accessRequest/accessRequestRoutes";
import changeNotificationRoutes, {
  changeNotificationRouteNames,
} from "./views/changeNotification/changeNotificationRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  passwordChanged: "PasswordChanged",
  notAuthorized: "NotAuthorized",
  notImplemented: "NotImplemented",
  distributor: {
    ...distributorRouteNames,
  },
  distributorReport: {
    ...distributorReportRouteNames,
  },
  accessRequest: {
    ...accessRequestRouteNames,
  },
  changeNotification: {
    ...changeNotificationRouteNames,
  },
};

export const routes: RouterOptions["routes"] = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/not-implemented",
    component: NotImplemented,
    name: routeNames.notImplemented,
    meta: { title: "Not Implemented" },
  },
  ...distributorRoutes,
  ...distributorReportRoutes,
  ...accessRequestRoutes,
  ...changeNotificationRoutes,
  { path: "/:path(.*)", component: NotFound },
];
